import PropTypes from 'prop-types';
import React from 'react';

import styles from 'iss/styles/Input.styl';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';

export function BootstrapRadioGroup({onClick, onChange, inline, options, id, disabled, ...props}) {
  const selectedValue = props.value;
  const contents = options.map(({value, label}) => {
    const input = <input type="radio" className={styles.largeRadiobutton} name={id} id={id+"-"+value}
                      value={value} checked={value == selectedValue}
                      onClick={onClick} onChange={onChange}/>;

    // Not disabled attribute on input, since it is due to low-contrast hard to see which whether it is selected or not.
    const disabledClass = disabled ? styles.radioDisabled : null;
    if (inline) {
      return <label key={value} className={'radio-inline ' + disabledClass}>
        {input}
        {label}
      </label>;

    } else {
      return <div key={value} className="radio">
        <label className={disabledClass}>
          {input}
          {label}
        </label>
      </div>;
    }
  });

  return <BootstrapFormGroup id={id} {...props}>
    {inline && props.label ? <div>{contents}</div> : contents}
  </BootstrapFormGroup>;
}
BootstrapRadioGroup.propTypes = {
  id: PropTypes.string.isRequired,
};

export default BootstrapRadioGroup;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/RadioGroup.jsx